<template>
  <ItemDialog ref="copyCouponDialog">
    <template v-slot:content-area>
      <div class="dialog-header">
        <img
          :src="require('@/assets/img/icon/svg/icon-coupon-yellow.svg')"
          alt=""
        />
      </div>
      <div class="dialog-content">
        <span>{{ $t("Coupon.copiedCoupon") }}</span>
      </div>
    </template>
    <template v-slot:button-area>
      <button @click="closeDialog()" class="dialog-btn">OK</button>
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCopyCoupon",

  setup() {
    const copyCouponDialog = ref(null);

    const openDialog = () => {
      copyCouponDialog.value.open();
    };

    const closeDialog = () => {
      copyCouponDialog.value.close();
    };

    return {
      copyCouponDialog,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.dialog-header {
  text-align: center;
}

.dialog-content {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  margin: 30px 0px;
}

.dialog-btn {
  width: 100%;
  height: 38px;
  background: #f4b53f;
  border-radius: 22px;
  border: 1px solid #f4b53f;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
}
</style>
